import { MutationTree } from 'vuex'
import { IUserProfile, IAuthState } from '@/@types'

const mutations: MutationTree<IAuthState> = {
  IS_AUTHENTICATED_UPDATED: (state, isAuthenticated: boolean) => {
    state.isAuthenticated = isAuthenticated
  },
  USER_PROFILE_UPDATED: (state, userProfile: IUserProfile) => {
    state.userProfile = userProfile
  },
  SET_LEAD_ALIAS: (state, alias: string) => {
    state.userLeadAlias = alias
  },
  IS_TWO_FACTOR_REQUIRED_UPDATED: (state, isTwoFactorRequired: boolean) => {
    state.isTwoFactorRequired = isTwoFactorRequired
  },
}

export default mutations
